jQuery(document).ready(function ($) {
  $('[data-lm-trigger]').on('click', function () {
    let $trigger = $(this);
    let data = $(this).data();
    let $con = $(`[data-lm-wrap="${data.lmTrigger}"]`);
    let url = window.tpdata.base_url + data.ep + '/';
    $trigger.addClass('loading');
    $con.addClass('loading');
    // if(!data.hasMore){
    //   $trigger.hide();
    // }
    let req = $.ajax(url, {
      data: data
    }).then(function (res) {
      $trigger.removeClass('loading');
      $con.append(res.out);
      $con.removeClass('loading');
      $trigger.data('offset', data.offset + res.length);
      if (res.postsLeft === false) {
        console.log(res);
        $trigger.hide();
      }
    })
  })


});